import './index.css'

const TabItem = props => {
  const {tabDetails, updateActiveId, isActive} = props
  const {displayText, tabId} = tabDetails
  const onClickTabItem = () => {
    updateActiveId(tabId)
  }
  const isActiveClassName = isActive ? 'active-tab-btn ' : ''
  return (
    <li className="tab-item-container ">
      <button
        type="button"
        className={`tab-btn ${isActiveClassName}`}
        onClick={onClickTabItem}
      >
        {displayText}
      </button>
    </li>
  )
}

export default TabItem
